import React, { useState } from 'react'
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar'
import { FaArrowLeft, FaSearch, FaCamera, FaFile, FaImage, FaFolder } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import camera from '../../../../images/camera.svg'
import attach from '../../../../images/attachment.svg'
import { DropdownMenu } from '../../../../data'
import { Container, Row, Col,Form,Dropdown, Button } from 'react-bootstrap'


const EmployerNewMessages = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  }
  return (
    <div>
      <EmployerNavbar/>
      <Container fluid className='p-0'>
          <Row className='gap-0'>
            <Col  >
            <div className='message-head py-3 mt-4 d-flex align-items-center'>
              <Link to='/employermessages' className='ps-3'>
                <FaArrowLeft  className='message-arrow'/>
              </Link>
              <h2 className='ps-3'>Send Message</h2>
           
           </div>
           <Form className='p-3 mb-5 pb-5' > 
            <Form.Group className="" >
              <Form.Label className='message-label'>To:</Form.Label>
              <div className='mt-2' style={{position:'relative'}}>
              <FaSearch className='input-box-icon ' />
              <Form.Control type="text" placeholder="Type names of multiple names" className='p-2 ps-5  input-field-border'/>
              </div>
            </Form.Group>
            
          </Form>
          <div className='' style={{paddingTop:'200px'}}>
            <div className='write-message d-flex align-items-center py-2 px-1 mt-5 mb-2'>
            <Form.Control type="text" placeholder="Write a message ..." className='border-0 p-2 ps-4'  />
            
            <Dropdown className='mt-2' style={{width:'23%'}}>
              <Dropdown.Toggle as={Button} variant="link" className="image-button ">
            <img src={attach} className='me-xl-4 me-lg-2 me-md-0 ' style={{width:'28px', height:'30px'}}/>
            </Dropdown.Toggle>
            <Dropdown.Toggle as={Button} variant="link" className="image-button">
            <img src={camera} style={{width:'28px', height:'30px'}}/>
            </Dropdown.Toggle>
            <Dropdown.Menu>
            {DropdownMenu.map((menu) => {
              const {id,text,icon} = menu;
              return(
                <Dropdown.Item className='d-flex justify-content-between'>
                  
                      {text} <img  className='drop-icon' src={icon}/>
                    
                </Dropdown.Item>
                )
                })}    
            </Dropdown.Menu>
            </Dropdown>
            
           </div>
           </div>
            </Col>
            <Col md={5} className='d-none d-md-flex'>
            <div className='empty'></div>
            </Col>
          </Row>
          
          
      </Container>
    </div>
  )
}

export default EmployerNewMessages
